module.exports = __webpack_public_path__ + "img/front.0fde97e0.png";